import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="clipboard"
export default class extends Controller {
  static targets = ["copiedIcon", "copyIcon"]

  static values = {
    text: { type: String, default: "" },
    preventDefault: { type: Boolean, default: false },
    copiedDuration: { type: Number, default: 1500 },
  }

  async copy(event) {
    try {
      await navigator.clipboard.writeText(this.textValue)
      this.showCopiedState()
    } catch (_error) {
      return
    }

    if (this.preventDefaultValue === true) {
      event.preventDefault()
    }
  }

  showCopiedState() {
    if (!this.hasCopyIconTarget || !this.hasCopiedIconTarget) return

    this.copyIconTarget.classList.add("hidden")
    this.copiedIconTarget.classList.remove("hidden")

    clearTimeout(this.copiedTimeout)
    this.copiedTimeout = setTimeout(() => {
      this.copiedIconTarget.classList.add("hidden")
      this.copyIconTarget.classList.remove("hidden")
    }, this.copiedDurationValue)
  }
}
